import { useEffect, useState } from "react";
import { base_url } from "../../config";
import axios from "axios";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import Workshops from "./Workshops";
import Tutorials from "./Tutorials";
import Stats from "./Stats";

export default function App() {
  const [ws, setWs] = useState([]);
  const [tut, setTut] = useState([]);
  const [wstutDays, setWsTutDays] = useState([]);
  const [loadingWs, setLoadingWs] = useState(true);
  const [loadingTut, setLoadingTut] = useState(true);
  const [loadingChartData, setLoadingChartData] = useState(true);

  useEffect(() => {
    setLoadingTut(true);
    setLoadingWs(true);
    setLoadingChartData(true);
    // Fetch workshops and tutorials data
    axios
      .get(`${base_url}/api/admin/get_ws`)
      .then((response) => setWs(response.data))
      .catch((error) => console.error("Error fetching workshops:", error))
      .finally(() => setLoadingWs(false));
    axios
      .get(`${base_url}/api/admin/get_tut`)
      .then((response) => setTut(response.data))
      .catch((error) => console.error("Error fetching students:", error))
      .finally(() => setLoadingTut(false));
    axios
      .get(`${base_url}/api/admin/get_ws_tut_days`)
      .then((response) => {
        
        setWsTutDays({...response.data})
      })
      .catch((error) => console.error("Error fetching data:", error))
      .finally(() => setLoadingChartData(false));
  }, []);

  const [value, setValue] = useState("one");
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const TabPanel = (props) => {
    if (value === props.value) {
      return <div className="mt-4 p-2">{props.children}</div>;
    }
  };

  if (loadingWs || loadingTut || loadingChartData) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-500"></div>
      </div>
    );
  }
  return (
    <>
      <Box sx={{ width: "100%" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="wrapped label tabs example"
        >
          <Tab value="one" label="Stats" wrapped />
          <Tab value="two" label="Workshops" />
          <Tab value="three" label="Tutorials " />
        </Tabs>
      </Box>
      <TabPanel value="one">
        <Stats ws={ws} tut={tut} wstutDays={wstutDays} />
      </TabPanel>
      <TabPanel value="two">
        <Workshops ws={ws} />
      </TabPanel>
      <TabPanel value="three">
        <Tutorials tut={tut} />
      </TabPanel>
    </>
  );
}
